export class ElemInstalacionNuevaInstalacion {
  idTipo: number;
  idAccion: number;
}
